import { requests } from './request'
import { CommissionType } from '../models/commission.interface'
import { request } from 'http'

export const commissionApi = {
    getInfo: (address: string): Promise<any> => requests.get('affiliate/info'),
    withdrawCommission: (): Promise<any> => requests.post(`withdraw/request-withdraw`),
}